import axiosInstance from '../helpers/axios.helper';

const getDistributionCutoff = (options = {}) => {
  return axiosInstance.get('/api/v2/affiliate_market_order_cutoff', {}, options);
};

const postDistributionCutoff = (cutoff, email) => {
  return axiosInstance.post('/api/v2/affiliate_market_order_cutoff', postParams({ cutoff, email }));
};

const postParams = ({ cutoff, email }) => {
  return { orderCutoff: { cutoff, email } };
};

export const distributionCutoffService = {
  getDistributionCutoff,
  postDistributionCutoff
};



// WEBPACK FOOTER //
// ./src/services/distributionCutoff.service.js